<template>
  <form class="plr3 pt3" @submit.prevent="submit" v-if="visible">
    <v-tabs type="card" :active="tab" @change="tab = $event" style="width: 230px; margin: 0 auto;" v-if="!~['357', '362'].indexOf(aid)">
      <v-tab title="学校" />
      <v-tab title="社区" />
    </v-tabs>
    <div style="margin-left: -15px">
      <v-field
        class="mt3 fs16"
        type="tel"
        v-model="mobile"
        placeholder="请输入手机号码"
        pattern="^1[3456789][0-9]{9}$"
        maxlength="11"
        autofocus
        clearable
      />
      <v-field
        class="mt3 fs16"
        type="tel"
        v-model="captcha"
        placeholder="请输入验证码"
        maxlength="6"
        clearable
        v-if="!~['njmeibo'].indexOf(CLIENT_ENV)"
      >
        <v-button
          slot="button"
          size="small"
          type="primary"
          :disabled="!!countdown || !mobile"
          @click.prevent="getCaptcha(mobile)"
        >{{ countdown ? countdown + '秒' : '获取验证码' }}</v-button>
      </v-field>
      <div />
    </div>
    <div class="flex align-items-center mt4">
      <a
        class="flex1 block mt2 tc fs14 underline"
        @click="$router.push(`/eyecheck/${(tab + 1) * 10}`)"
        v-if="!~['njmeibo'].indexOf(CLIENT_ENV) && setting.report_by_mobile === 0"
      >跳过</a>
      <v-button
        class="flex1"
        type="primary"
        native-type="submit"
        :loading="validating"
        :disabled="!mobile"
        block
      >查询</v-button>
    </div>
  </form>
  <div class="tc pt2" v-else>正在加载...</div>
</template>

<script>
import cookie from 'js-cookie';
import { Button, Field, Tabs, Tab, Notify } from 'vant';
import { getCaptcha, validateCaptcha } from '../../api';

export default {
  components: {
    VButton: Button,
    VField: Field,
    VTabs: Tabs,
    VTab: Tab,
  },
  data() {
    const aid = localStorage.getItem('aid');
    const initType = ~['357'].indexOf(aid) ? 20 : 10;
    const setting = JSON.parse(localStorage.getItem('setting')) || {};
    const type = +cookie.get(`type_${aid}`) || initType;
    const mobile = cookie.get(`mobile_${aid}`) || undefined;

    return {
      visible: false,
      tab: (type / 10) - 1,
      validating: false,
      countdown: 0,
      timer: null,

      mobile,
      captcha: undefined,
      captcha_id: undefined,

      aid,
      setting,
      CLIENT_ENV: window.CLIENT_ENV,
    }
  },
  created() {
    // if (this.setting.report_by_mobile === 0) {
    //   this.$router.replace('/eyecheck/10');
    //   return;
    // }
    if (this.mobile) {
      this.$router.replace('/eyecheck/result');
      return;
    }
    this.visible = true;
  },
  methods: {
    async getCaptcha(mobile) {
      if (!/^1[3456789][0-9]{9}$/.test(mobile)) {
        Notify('请输入正确的手机号！');
        return;
      }
      const data = await getCaptcha({ mobile });
      this.countdown = 60;
      this.captcha_id = data.id;
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown < 0) {
          this.countdown = 0;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async submit() {
      if (!~['localhost:8080', 'demo2', 'njmeibo'].indexOf(this.CLIENT_ENV)) {
        this.validating = true;
        await validateCaptcha({
          mobile: this.mobile,
          captcha_id: this.captcha_id,
          captcha: this.captcha,
        }).catch((e) => {
          this.validating = false;
          throw e;
        });
        this.validating = false;
      }

      const type = (this.tab + 1) * 10;
      cookie.set(`type_${this.aid}`, type, { expires: 365 });
      cookie.set(`mobile_${this.aid}`, this.mobile, { expires: 365 });

      this.$router.push({
        path: '/eyecheck/result',
        query: {
          type,
          mobile: this.mobile,
        }
      })
    },
  }
}
</script>

